// =====================================
//
//   閒置過久被登出提示的視窗
//
//   @author Gray
//   @time 2016 / 04 / 28
//
// =====================================

window.InifECApp.directive('logoutAlert', ['$rootScope', '$ngModal', '$timeout', 'UserService',
	function ($rootScope, $ngModal, $timeout, UserService) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            // ------------------------------
            //  開啟 modal
            // ------------------------------
            var openModal = function() {
            	$ngModal.openModal('logout-alert');
            }

            // ------------------------------
            //  關閉 modal
            // ------------------------------
            var closeModal = function() {
            	$ngModal.closeModal('logout-alert');
            }

            // ------------------------------
            // 登入
            // ------------------------------
            var login = function() {

                closeModal();

                $rootScope.$broadcast('OPEN_LOGIN_MODAL');
            }

            // ------------------------------
            //
            // 因為server已經回傳未登入
            // 所以這邊要檢查目前UserService的資料是否為空
            // 如果不為空要清空，並打開提示使用者已經被登出的modal
            // 避免使用者以為已經登入
            // 
            // ------------------------------
            var checkIsLogut = function() {

                var user = UserService.user;

                // 檢查目前是否有cache住user資料，
                if(user && user.mrscid) {

                    // 確實清除所有登入資料
                    UserService.logout().then(function(result) {
                        $rootScope.$broadcast('LOGOUT_SUCCESS');
                        openModal();
                    }, function(error) {
                        $rootScope.$broadcast('LOGOUT_SUCCESS');
                        openModal();
                    });
                }
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_LOGOUT_ALERT_MODAL', function(event, data) {
                
                checkIsLogut();
            });

            /*==========================
                Members
            ==========================*/

            /*==========================
                Methods
            ==========================*/
            $scope.login = login;

            
            /*==========================
                init
            ==========================*/

		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "partials/modal/logout_alert.html";
		_dir.controller = controller;

		return _dir;
	}]
);